import React from "react";

import * as styles from "./VerifiedPill.module.scss";

const VerifiedPill = () => {
  return <span className={styles.verifiedLabel}>Verified</span>;
};

export { VerifiedPill };
